import {PacklineColumn} from "@modules/shipment/models/cw-shipment.model";

export class UpdatePacklineColumns {
  public static readonly type = '[PackLines] Change Column setings';

  constructor(public payload: { columns: PacklineColumn[] }) {}
}
